import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  drawer: {
    width: 240,
    flexShrink: 0,

  

  },

  "& .MuiDrawer-paper": {
    width: 240,

    backgroundColor: theme.palette.background.defult,
    boxSizing: "border-box",
  },

  itemIcon: {
    size: 28,
    color: theme.palette.secondary.main,
  },
  itemText: {
    fontWeight: "600",
    fontSize: "16px",
    margin: "7px",

    color: theme.palette.primary.main,
  },
  drawerHeader: {
    //backgroundColor:"white",
  },
  headerTitle: {
    size: 27,
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginRight: "50px",
  },
}));
